<!-- 生年月日入力コンポーネント -->
<template>
    <dd :class="validate.$error | klass">
        <template v-if="validate.$error">
            <span v-if="!validate.required" class="errNote">生年月日を入力してください。</span>
            <span v-if="!validate.dateRule" class="errNote">有効な日付を入力してください。</span>
            <span v-if="!validate.birthdayRule" class="errNote">未来の日付は登録できません。</span>
        </template>
        <label class="select">
            <select v-model="birth.year">
                <option value="">年</option>
                <option v-for="index in selectEndYear"
                        :value="year(index)">{{ year(index) }}</option>
            </select>
        </label>
        <label class="select">
            <select v-model="birth.month">
                <option value="">月</option>
                <option v-for="month in 12"
                        :value="month | zeroPadding">{{ month | zeroPadding }}</option>
            </select>
        </label>
        <label class="select">
            <select v-model="birth.day">
                <option value="">日</option>
                <option v-for="day in 31"
                        :value="day | zeroPadding">{{ day | zeroPadding }}</option>
            </select>
        </label>
        <input v-model="validate.$model"
               name="birthday_ymd"
               type="hidden">
    </dd>
</template>

<script>
import dayjs from 'dayjs'
import { mixinUserInfoFieldComponent } from '../../mixin/utility'

export default {
    name: 'UserInfoBirthdayField',
    mixins: [mixinUserInfoFieldComponent],
    props: {
        validate: {
            type: Object,
            required: true
        }
    },
    data: function(){
        return {
            birth: {
                year: '1993',
                month: '',
                day: ''
            },
            startYear: (1920 - 1)
        }
    },
    computed: {
        birthday: {
            get: function(){
                const birth = this.birth;
                const isEmpty = Object.keys(birth).some(function(key){
                    return birth[key] === '';
                });

                return isEmpty? '': [birth.year, birth.month, birth.day].join('');
            },
            set: function(value){
                const regex = new RegExp(/^(\d{4})(\d{2})(\d{2})$/);
                const match = this.validate.$model.match(regex);
                if (match) {
                    this.birth.year = match[1];
                    this.birth.month = match[2];
                    this.birth.day = match[3];
                }
            }
        },
        selectEndYear: function(){
            return dayjs().format('YYYY') - this.startYear;
        }
    },
    watch: {
        birth: {
            handler: function(){
                this.validate.$model = this.birthday;
                this.setUserInfoPatch(this.birthday);
            },
            deep: true
        }
    },
    filters: {
        zeroPadding: function(number){
            return ("0" + number).slice(-2);
        }
    },
    created: function(){
        if (!this.validate.$model) {
            // null のとき空文字に変換して処理する
            this.validate.$model = '';
            // 親のデータを更新する
            this.setUserInfoPatch(this.validate.$model);
        }
        this.birthday = this.validate.$model;
    },
    methods: {
        year: function(index){
            return index + this.startYear;
        },
        setUserInfoPatch: function(value){
            this.$emit('set-user-info-patch', 'birthday_ymd', value);
        }
    }
}
</script>
